/**
 * React hook for monitoring online/offline status
 * Uses both navigator.onLine and actual server reachability
 */

import { useEffect, useState } from "react";
import { isOnline as checkIsOnline, onConnectionChange } from "@/lib/sync/network-detector";

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(() => checkIsOnline());

  useEffect(() => {
    // Listen for network status changes
    const unsubscribe = onConnectionChange((online) => {
      setIsOnline(online);
    });

    // Also listen to native browser events as backup
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      unsubscribe();
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
}
